import { RiPagesLine } from "react-icons/ri";
import { defineField, defineType } from "sanity";

export default defineType({
  name: "microContentFareSection",
  title: "Fare Section",
  type: "document",
  icon: RiPagesLine,
  fieldsets: [
    {
      name: "fare",
      title: "Fare Section",
      options: { collapsible: true, collapsed: true }
    },
    {
      name: "onboardBenefits",
      title: "Onboard Benefits",
      options: { collapsible: true, collapsed: true }
    }
  ],
  fields: [
    defineField({
      name: "fareSection",
      type: "blockContentSectionTitle",
      fieldset: "fare"
    }),
    defineField({
      name: "pricesValidUntil",
      title: "Prices valid until",
      type: "multilingualArrayBlockContent",
      fieldset: "fare"
    }),
    defineField({
      name: "onboardBenefitSectionTitle",
      title: "Onboard Benefit Section Title",
      type: "multilingualArrayBlockContent",
      fieldset: "onboardBenefits"
    }),
    defineField({
      name: "onboardBenefitSectionDescription",
      title: "Onboard Benefit Section Description",
      type: "multilingualArrayBlockContent",
      fieldset: "onboardBenefits"
    })
  ],
  preview: {
    prepare(value) {
      return {
        title: "Fare Section"
      };
    }
  }
});
